import axios from 'axios';
import BaseAPI from './base/base-api';

class CertificateTrialAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'certificatetrial';

}

export default new CertificateTrialAPI();